<template>
  <div>
    <PageHeading
      default-heading="Something's not syncing correctly"
      edit-heading="Something's not syncing correctly"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <p>
          It looks like {{ idVerificationName() }}'s ID verification didn't sync yet.
          Please confirm they have completed the process, and click retry to refresh the data and finish opening the account.
        </p>
        <br>
        <p>If Retry doesn't work, you can send a new SMS link to their phone to try ID verification again.</p>
        <br>
        <p>
          <u>
            <a id="resend-id-link">
              <router-link to="/trust-doc-verify-resend-sms">Resend a new SMS link</router-link>
            </a>
          </u>
        </p>
      </div>
      <NavigationComponent @next-action="handleWidgetSubmit" />
    </form>
  </div>
</template>
<script>
import utilityFunctions from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import NavigationComponent from '../components/NavigationComponent.vue';

export default {
  name: 'TrustDocVerifyNotComplete',
  components: {
    NavigationComponent,
  },
  mixins: [
    utilityFunctions,
    PageHeading,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  computed: {
    pageHeader() {
      const pageHeader = this.pd_content.page_header;
      if (pageHeader) {
        const heading = this.cs_editMode ? pageHeader.edit : pageHeader.default;

        if (heading) {
          document.title = this.setTitle(heading);
        }
        return heading;
      }
      return '';
    },
  },
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-doc-verify-not-complete' });
  },
  methods: {
    idVerificationName() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
      }
      return `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}
#resend-id-link {
  color: black;
}
</style>
